<ng-container *ngIf="worker">
  <ng-container *transloco="let t">
    <c-container>
      <c-row>
        <c-col>
          <h5>{{ t('Manage Your SPOT Device') }}</h5>
          <br/>
          {{ t('SPOT Devices can now be linked to OK Alone. This means you can update your status and location using your SPOT device.') }}
          <br/>
          {{ t('Note: This is a new feature. Please email us at customer.support@ok-alone.com if you want to use your SPOT Device') }}
          <br/>
          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-location-pin"></i> ESN</label>
              <div class="col-8">
                <input
                  [formControlName]="'spot'"
                  cFormControl
                  placeholder="0-0000000"
                />
                {{ t('Enter Your SPOT device ESN number, e.g') }} 0-2024164
              </div>
            </div>
            <c-row>
              <c-col xs="6" class="mt-3">
                <button cButton class="px-4 text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i> {{ t('Update your SPOT Device') }}
                </button>
              </c-col>
            </c-row>
          </form>
          <hr/>
          <div>
            <h5>{{ t('Learn How to Connect your SPOT Device') }}</h5>
            {{ t('To learn how to connect your SPOT Device to work with OK Alone please follow the link below.') }}
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/35908534519697-Link-SPOT-to-Ok-Alone-with-SPOT-s-Data-Push" target="_new">https://okalone.zendesk.com/hc/en-gb/articles/35908534519697-Link-SPOT-to-Ok-Alone-with-SPOT-s-Data-Push</a>
          </div>
        </c-col>
        <c-col>
          <img src="assets/images/spot-esn.png" alt="SPOT ESN Example" class="img-thumbnail img-responsive pull-right"/>
        </c-col>
      </c-row>
    </c-container>
  </ng-container>
</ng-container>
